import React from "react";

interface ModalOverlayProps {
  onClose: () => void;
}

const ModalOverlay: React.FC<ModalOverlayProps> = ({ onClose }) => {
  return (
    <div
      className="absolute inset-0 bg-black bg-opacity-50"
      onClick={onClose}
    />
  );
};

export default ModalOverlay;
